export class CachedSet<T> implements Set<T> {

  private internal: Set<T>;

  public get [Symbol.toStringTag](): string {
    return this.internal[Symbol.toStringTag];
  }

  constructor(private CacheKey: string) {
    const cache = sessionStorage.getItem(CacheKey);

    if (cache) {
      try {
        this.internal = new Set<T>(JSON.parse(cache));
      } catch {
        this.internal = new Set<T>();
        sessionStorage.setItem(this.CacheKey, '[]');
      }
    } else {
      this.internal = new Set<T>();
    }
  }

  public add(value: T): this {
    this.internal.add(value);
    sessionStorage.setItem(this.CacheKey, JSON.stringify(Array.from(this.internal.values())));
    return this;
  }

  public clear(): void {
    this.internal.clear();
    sessionStorage.setItem(this.CacheKey, '[]');
  }

  public delete(value: T): boolean {
    var r = this.internal.delete(value);
    sessionStorage.setItem(this.CacheKey, JSON.stringify(Array.from(this.internal.values())));
    return r;
  }

  public forEach(callbackfn: (value: T, value2: T, set: Set<T>) => void, thisArg?: any): void {
    return this.internal.forEach(callbackfn);
  }

  public has(value: T): boolean {
    return this.internal.has(value);
  }

  public get size(): number {
    return this.internal.size;
  }

  public [Symbol.iterator](): IterableIterator<T> {
    return this.internal[Symbol.iterator]();
  }

  public entries(): IterableIterator<[T, T]> {
    return this.internal.entries();
  }

  public keys(): IterableIterator<T> {
    return this.internal.keys();
  }

  public values(): IterableIterator<T> {
    return this.internal.values();
  }
}
